import * as Sentry from "@sentry/react";
import type { SupportedKioskLanguage } from "./kiosk-launch";
import { toSupportedKioskLanguage } from "./kiosk-launch";

type BridgeCallbacks = {
  setLanguage(language: SupportedKioskLanguage): void;
  requestClose(): void;
};

export const postNativeEvent = (
  handler: KioskNativeHandler | undefined,
  status: "ready" | "closed" | "profile-created",
) => {
  if (!handler) return false;
  try {
    handler.postMessage(JSON.stringify({ version: 1, status }));
    return true;
  } catch (error) {
    Sentry.captureException(error);
    return false;
  }
};

export const installKioskBridge = (
  target: Window,
  callbacks: BridgeCallbacks,
) => {
  const bridge: NonNullable<Window["fitnextKioskV1"]> = {
    setLanguage(languageCode) {
      const language = toSupportedKioskLanguage(languageCode);
      if (language) callbacks.setLanguage(language);
    },
    requestClose: callbacks.requestClose,
  };
  target.fitnextKioskV1 = bridge;
  postNativeEvent(target.kioskBridgeHandler, "ready");

  return () => {
    if (target.fitnextKioskV1 === bridge) {
      delete target.fitnextKioskV1;
    }
  };
};
